import { BaseState } from '@/store/base-state';
import {
  Organizations,
  ModelAccreditationFilters,
} from '@/modules/organizations/types';
import { TableOptions } from '@/types';

export default class ModelAccreditationState extends BaseState {
  model_accreditation: Organizations.ModelAccreditation[] = []
  filters_accreditation: ModelAccreditationFilters = {
    is_only_accredited: false,
  };

  model_accreditation_loading = false
  accredited_count = 0

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['name'],
    sortDesc: [true],
  };
}
